import axios from 'axios';
import {
    DELETE_CUSTOMER,
    GET_CUSTOMER,
    GET_CUSTOMERS,
    POST_CUSTOMER,
    UPDATE_CUSTOMER
} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_CUSTOMERS, options);
    },
    async get(customer, options = {}) {
        return await axios.get(GET_CUSTOMER(customer), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_CUSTOMER, data, options);
    },
    async update(customer, data, options = {}) {
        return await axios.patch(UPDATE_CUSTOMER(customer), data, options);
    },
    async delete(customer, options = {}) {
        return await axios.delete(DELETE_CUSTOMER(customer), options);
    },
    async post(url, data, options) {
        url = 'api/customers/import'
        data = (() => {
            const formData = new FormData()
            formData.append('file', data)
            return formData
        })()
            options = {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
            return await axios.post(url, data, options)
    }
};
